import { Logout } from "@mui/icons-material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingButton from '@mui/lab/LoadingButton';
import { AppDispatch, RootState } from "../../state/store";
import { logout } from "../../state/authentication/authenticationSlice";
import { LocalStorageAuth } from "../../utils/LocalStorageAuth";
import { apiClient } from "../../utils/ApiClient";
import { Logger } from "../../utils/Logger";
import { trackLogout } from "../../utils/Infralytiqs";
import { useLoginPath } from "../../hooks/useLoginPath";

export const LogoutButton: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const loginPath = useLoginPath();
  const user = useSelector((state: RootState) => state.authentication.user);
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);

  const handleLogout = async () => {
    if (isLoggingOut) return; // Prevent multiple clicks
    
    setIsLoggingOut(true);

    // Fire before we clear state/redux so we still have the user's email.
    trackLogout(user?.email, { userId: user?._id, companyId: user?.companyId });

    try {
      try {
        await apiClient.post("/auth/logout", {});
      } catch (e) {
        Logger.warn("LogoutButton", `Server logout failed (continuing local logout): ${e}`);
      }

      LocalStorageAuth.clearAll();

      dispatch(logout());
      
      // Navigate to login page using React Router (no page refresh)
      navigate(loginPath);
    } catch (error) {
      console.error('Logout error:', error);
      setIsLoggingOut(false);
    }
  };

  return (
    <LoadingButton
      variant="contained" 
      color="secondary" 
      startIcon={<Logout />}
      onClick={handleLogout}
      loading={isLoggingOut}
      loadingPosition="start"
    >
      Logout
    </LoadingButton>
  );
};


